import Cookies from 'js-cookie'
import anime from 'animejs'

export default class Notice {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
    this.bindEvents()
  }
  setVars() {
    this.closeTrigger = this.el.querySelector('[data-notice-dismiss]')
    this.rememberState = this.el.dataset.remember
    this.noticeOpen = Cookies.get('noticeOpen')
  }

  init() {
    if (this.rememberState !== 'true') {
      return
    }
    if (typeof this.noticeOpen === 'undefined') {
      this.el.classList.add('visible')
      this.updateCookie('visible')
    } else if (this.noticeOpen !== 'visible') {
      this.el.classList.add('hidden')
      this.el.classList.remove('visible')
    } else {
      this.revealNotice(this.el)
    }
  }

  bindEvents() {
    this.closeTrigger.addEventListener('click', this.handleLinkClick.bind(this))
  }

  updateCookie(status) {
    if (this.rememberState === 'true') {
      Cookies.set('noticeOpen', status)
      this.noticeOpen = Cookies.get('noticeOpen')
    }
  }

  revealNotice(el) {
    if (el.classList.contains('hidden')) {
      let endHeight = this.getNoticeHeight()
      el.classList.remove('hidden')
      anime({
        targets: el,
        easing: 'linear',
        height: [0, endHeight + 'px'],
        duration: 350,
        complete: function(anim) {
          el.classList.add('visible')
        }
      })
    } else {
      this.el.classList.add('visible')
    }
  }
  getNoticeHeight = () => {
    let notice = this.el
    let height = 0
    if (notice.classList.contains('hidden')) {
      notice.classList.add(...['visible', 'opacity-0', 'absolute'])
      notice.classList.remove('hidden')
      height = notice.offsetHeight
      notice.classList.add('hidden')
      notice.classList.remove(...['visible', 'opacity-0', 'absolute'])
    } else {
      height = notice.offsetHeight
    }
    return height
  }

  handleLinkClick() {
    let notice = this.el
    let height = this.getNoticeHeight()
    anime({
      targets: notice,
      easing: 'easeInOutSine',
      height: [height, 0],
      duration: 300,
      complete: function(anim) {
        notice.classList.add('hidden')
        notice.classList.remove('visible')
      }
    })
    if (this.rememberState === 'true') {
      this.updateCookie('hidden')
    }
  }
}
